import { useState, useEffect, useRef } from 'react'

import { products } from './products'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Carousel from 'react-bootstrap/Carousel'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'

import axios from 'axios'
import Slider from "react-slick"
import DatePicker from "react-datepicker"
import Marquee from "react-marquee-slider"
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api'

import { Calendar, Calendar3, EnvelopeFill, Facebook, GeoAlt, GeoAltFill, Instagram, Linkedin, Palette, TelephoneFill, Tiktok, Whatsapp, Youtube } from 'react-bootstrap-icons'

import 'bootstrap/dist/css/bootstrap.min.css'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "react-datepicker/dist/react-datepicker.css";
import './App.css'

import logo from './img/logo.png'
import fundacion from './img/fundacion.jpg'
import girl from './img/girl.png'
import man from './img/man.png'
import woman from './img/woman.png'
import policy from './img/politicas-de-garantia.jpg'
import ani from './img/ani.png'
import eye from './img/eye.png'

import home0 from './img/home0.jpg'
import home1 from './img/home1.jpg'
import home2 from './img/home2.jpg'
import home3 from './img/home3.jpg'
import home4 from './img/home4.jpg'

import banner1 from './img/banner1.jpg'
import banner2 from './img/banner2.jpg'
import banner3 from './img/banner3.jpg'

import slide1 from './img/lentes01.jpg'
import slide2 from './img/lentes02.jpg'
import slide3 from './img/lentes03.jpg'
import slide4 from './img/lentes04.jpg'
import slide5 from './img/lentes05.jpg'
import slide6 from './img/lentes06.jpg'
import slide7 from './img/lentes07.jpg'
import slide8 from './img/lentes08.jpg'
import slide9 from './img/lentes09.jpg'
import { ModalBody } from 'react-bootstrap'

//const API_GET = 'https://grupoopticojardines.com.mx/api/optica/findAvailableDay';
//const API_POST = 'https://grupoopticojardines.com.mx/api/optica/create';
const API_GET = 'https://somosglotones.com/srv/api/euk/optica/getEvents';
const API_POST = 'https://somosglotones.com/srv/api/euk/optica/createEvent';
const HOST = 'https://grupoopticojardines.com.mx/'
//const HOST = 'http://localhost:3000/'

const containerStyle = {
  width: '100%',
  height: '600px'
};

const center = {
  lat: 19.654175,
  lng: -99.208518
};

const centerMark = {
  lat: 19.6543131,
  lng: -99.2085744
};

const isToday = (date) => {
  const today = new Date();

  if (today.toDateString() === date.toDateString()) {
    return true;
  }

  return false;
}

const photos = [
  HOST + "clientes/ray.png",
  HOST + "clientes/boss.png",
  HOST + "clientes/calvin.png",
  HOST + "clientes/cloe.png",
  HOST + "clientes/guess.png",
  HOST + "clientes/lacoste.png",
  HOST + "clientes/prada.png",
  HOST + "clientes/tous.png",
  HOST + "clientes/vugue.png"
];

function App() {
  const lentes = [slide1, slide2, slide3, slide4, slide5, slide6, slide7, slide8, slide9];
  //const hours = [ '10:00 AM - 11:00 AM', '11:00 AM - 12:00 PM', '12:00 PM - 1:00 PM', '1:00 PM - 2:00 PM', '2:00 PM - 3:00 PM', '3:00 PM - 4:00 PM', '4:00 PM - 5:00 PM', '5:00 PM - 6:00 PM', '6:00 PM - 7:00 PM', '7:00 PM - 8:00 PM' ];
  const hours = [
    { hour: 10, value: '10:00 AM - 11:00 AM' },
    { hour: 11, value: '11:00 AM - 12:00 PM' },
    { hour: 12, value: '12:00 PM - 1:00 PM' },
    { hour: 13, value: '1:00 PM - 2:00 PM' },
    { hour: 14, value: '2:00 PM - 3:00 PM' },
    { hour: 15, value: '3:00 PM - 4:00 PM' },
    { hour: 16, value: '4:00 PM - 5:00 PM' },
    { hour: 17, value: '5:00 PM - 6:00 PM' },
    { hour: 18, value: '6:00 PM - 7:00 PM' },
    { hour: 19, value: '7:00 PM - 8:00 PM' }
  ];

  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const [showDates, setShowDates] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [showItem, setShowItem] = useState(false)

  const [isLoading, setLoading] = useState(false);
  const [title, setTitle] = useState("")
  const [message, setMessage] = useState("")

  const [startDate, setStartDate] = useState(new Date());
  const [hour, setHour] = useState("");
  const [hourSelected, setHourSelected] = useState(-1);
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [comments, setComments] = useState("");

  const [availableHours, setAvailableHours] = useState([])
  const [itemSelected, setItemSelected] = useState('')

  const [markerPoint, setMarkerPoint] = useState('');
  const [goingUp, setGoingUp] = useState(false);
  const prevScrollY = useRef(0);

  const refHome = useRef(null);
  const refServices = useRef(null);
  const refFundation = useRef(null);
  const refContact = useRef(null);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1
  };

  useEffect(() => {
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      prevScrollY.current = currentScrollY;

      if (currentScrollY > 10)
        document.getElementById("rensa-navbar").className = "nav-bar-custom navbar navbar-expand-lg navbar-light fixed-top";
      else
        document.getElementById("rensa-navbar").className = "nav-bar-custom-start navbar navbar-expand-lg navbar-light fixed-top";
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);

  useEffect(() => {
    gettingDayAvailable()
  }, [startDate]);

  const gettingDayAvailable = () => {
    setLoading(true);
    axios.get(API_GET + "/" + formatDate(startDate) + "?rand=" + Math.random(), {}, {})
      .then(function (response) {

        console.log(response.data)
        let data = response.data
        var date = new Date(startDate);
        let hoursList = []

        hours.map((item, i) => {
          if (isToday(date)) {
            if (item.hour > date.getHours()) hoursList.push(item.value)
          } else hoursList.push(item.value)
        })

        if (data && data !== '') {
          data.map(item => {
            let milis = item.start.dateTime.value
            const fecha = new Date(milis);
            const hour = fecha.getHours()

            let el = hours.find(e => e.hour === hour)

            if (el) {
              var idx = hoursList.indexOf(el.value)

              console.log("hoy of event", idx, parseInt(hour), hoursList)
              if (idx > -1)
                hoursList.splice(idx, 1)
            }
          })
        }

        setAvailableHours(hoursList)
        setLoading(false)
      }).catch(function (err) {
        console.log("error", err)
        setLoading(false)
      });
  }

  const gettingDayAvailable_ = () => {
    setLoading(true);
    axios.get(API_GET + "/" + formatDate(startDate) + "?rand=" + Math.random(), {}, {})
      .then(function (response) {
        let data = response.data
        var date = new Date(startDate);
        let hoursList = []


        hours.map((item, i) => {
          //console.log('hour', item, isToday(date), date.getHours())

          /*if ( isToday(date) && ( ( ( (date.getHours() > 10) || (date.getHours() == 10) ) && item == '10:00 AM - 11:00 AM') ||
            ( ( (date.getHours() > 11) || (date.getHours() == 11) ) && item == '11:00 AM - 12:00 PM') ||
            ( ( (date.getHours() > 12) || (date.getHours() == 12) ) && item == '12:00 PM - 1:00 PM') ||
            ( ( (date.getHours() > 13) || (date.getHours() == 13) ) && item == '1:00 PM - 2:00 PM') ||
            ( ( (date.getHours() > 14) || (date.getHours() == 14) ) && item == '2:00 PM - 3:00 PM') ||
            ( ( (date.getHours() > 15) || (date.getHours() == 15) ) && item == '3:00 PM - 4:00 PM') ||
            ( ( (date.getHours() > 16) || (date.getHours() == 16) ) && item == '4:00 PM - 5:00 PM') ||
            ( ( (date.getHours() > 17) || (date.getHours() == 17) ) && item == '5:00 PM - 6:00 PM') ||
            ( ( (date.getHours() > 18) || (date.getHours() == 18) ) && item == '6:00 PM - 7:00 PM') ||
            ( ( (date.getHours() > 19) || (date.getHours() == 19) ) && item == '7:00 PM - 8:00 PM') ) ) {
              console.log('cumple', item, date.getHours())
              var element = document.getElementById('hour_' + i);
              element.disabled = true;
            } else {
              var element = document.getElementById('hour_' + i);
              element.disabled = false;
            }*/

          if (isToday(date)) {
            if (item.hour > date.getHours()) hoursList.push(item.value)
          } else hoursList.push(item.value)
        })
        /*response.data.map( item => {
          var idx = hours.indexOf( item.hour );
  
          var element = document.getElementById('hour_' + idx);
          element.setAttribute('disabled', '');
        })*/

        if (data !== '') {
          data.map(item => {
            var idx = hoursList.indexOf(item.hour)

            if (idx > -1)
              hoursList.splice(idx, 1)
          })
        }

        setAvailableHours(hoursList)
        setLoading(false)
      }).catch(function (err) {
        console.log("error", err)
        setLoading(false)
      });
  }

  const handleNavClick = (eventKey) => {
    const yOffset = -100;
    const element = eval(eventKey).current;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  const handleOnClick = (e) => {
    /*e.preventDefault();
    setLoading(true);
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
        handleOnSubmit(token);
      });
    });*/

    handleOnSubmit();
  }

  const handleOnSubmit = (e) => {
    e.preventDefault();
    let el = hours.find(e => e.value === hour)

    axios
      .post(API_POST + '?name=' + name + '&lastName=' + lastName + '&desc=' + comments + '&phone=' + phone + '&date=' + formatDate(startDate) + '&hour=' + el.hour + '&email=' + email, {})
      .then((res) => {

        if (res.data === 'done') {
          setTitle("¡Cita programada!")
          setMessage("Tu cita a quedado programada, pronto recibiras un correo de confirmación.")
          setShowMessage(true)
        } else {
          setTitle("Error")
          setMessage("Ocurrió un error, favor de intentarlo mas tarde.")
          setShowMessage(true)
        }

        clearForm()
      })
      .catch((err) => {
        setTitle("Error")
        setMessage("Ocurrió un error, favor de intentarlo mas tarde.")
        setShowMessage(true)

        clearForm()
      });
  }

  const handleOnSubmit__ = (e) => {
    e.preventDefault();

    var json = {
      'id': '',
      'name': name,
      'lastname': lastName,
      'phone': phone,
      'email': email,
      'date': formatDate(startDate),
      'hour': hour,
      'desc': comments,
    }

    axios
      .post(API_POST, json)
      .then((res) => {
        setTitle("¡Cita programada!")
        setMessage("Tu cita a quedado programada, pronto recibiras un correo de confirmación.")
        setShowMessage(true)

        clearForm()
      })
      .catch((err) => {
        setTitle("Error")
        setMessage("Ocurrió un error, favor de intentarlo mas tarde.")
        setShowMessage(true)

        clearForm()
      });
  }

  const clearForm = () => {
    setLoading(false)
    setName("")
    setLastName("")
    setComments("")
    setEmail("")
    setPhone("")
    setHour("")
    setStartDate(addOneDay(new Date()))

    setShowDates(false)
  }

  const handleMarker = () => {
    console.log("click")
    window.open("https://goo.gl/maps/AzrKRz1c2w6ShVai6")
  }

  const onLoad = map => {
    setTimeout(() => {
      setMarkerPoint(<Marker position={centerMark} onClick={handleMarker} />)
    }, 1000);
  }

  const handleOnChangeHour = (value) => {
    /*hours.map((item, i) => {
      var element = document.getElementById('hour_' + i);
      element.classList.remove("hour-group-active");
    })*/

    //var active = document.getElementById('hour_' + index);
    //active.classList.add("hour-group-active");
    //setHour(hours[index]);
    setHour(value)
    setHourSelected(value)
  }

  const isWeekday = (date) => {
    const day = new Date(date).getDay();
    return day !== 0;
  };

  const formatDate = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  const prettyFormat = (date) => {
    var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString("es-MX", options);
  }

  const addOneDay = (date) => {
    date.setDate(date.getDate() == 0 ? date.getDate() + 1 : date.getDate() + 0);
    return date;
  }
  const handleOnItem = (item) => {
    setShowItem(true)
    setItemSelected(item)
  }
  const handleMessage = (item) => {
    window.open('https://wa.me/5215621397439?text=Hola!%20Me%20interesa%20el%20armazón%20' + item.title, '_blank').focus();
  }

  return (
    <div className="App">

      <Modal show={showItem} onHide={() => setShowItem(false)} size='lg'>
        <div className="modal-content-background">
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="modal-body-style" align="center">
            <Container>
              <Row>
                <Col md={6}>
                  <div> <img src={itemSelected.url} className='item-img' /> </div>
                  <Container>
                    <Row>
                      <Col md={3}> <div> <img src={itemSelected.url} className='item-img' /> </div> </Col>
                      <Col md={3}> <div> <img src={itemSelected.url} className='item-img' /> </div> </Col>
                      <Col md={3}> <div> <img src={itemSelected.url} className='item-img' /> </div> </Col>
                      <Col md={3}> <div> <img src={itemSelected.url} className='item-img' /> </div> </Col>
                    </Row>
                  </Container>
                </Col>
                <Col md={6}>
                  <div className='item-title-view' align="left">{itemSelected.title}</div>
                  <div className='item-price-view' align="left">{itemSelected.price}</div>
                  <div className='item-desc-view' align="left">{itemSelected.desc}</div>
                  <br />
                  <div align="right">
                    <Button className='item-button-view' onClick={() => handleMessage(itemSelected)}> Me interesa </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </div>
      </Modal>

      <Modal show={showMessage} onHide={() => setShowMessage(false)}>
        <div className="modal-content-background">
          <Modal.Body className="modal-body-style" align="center">
            <Modal.Title>{title}</Modal.Title>
            <br />
            {message}
          </Modal.Body>
          <Modal.Footer className="modal-footer-style">
            <Button variant="warning" onClick={() => setShowMessage(false)}>
              Aceptar
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal show={showDates} size="lg" onHide={() => setShowDates(false)}>
        <Modal.Header closeButton></Modal.Header>
        <ModalBody>

          <Container>
            <Row>
              <Col md={12}>
                <div className="calendar-title">CALENDARIO DE CITAS</div>
                <div className="calendar-desc">Elige entre los dias y horarios disponibles.</div> <br />
              </Col>
            </Row>
          </Container>

          <Form id="dateForm" className="dateForm" onSubmit={handleOnSubmit}>
            <Container>
              <Form.Group>
                <Container>
                  <Row>
                    <Col md={'auto'}>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        filterDate={isWeekday}
                        minDate={addOneDay(new Date())}
                        showDisabledMonthNavigation
                        inline
                      />
                    </Col>
                    <Col>
                      <Container>
                        <Row className='align-items-center'>
                          <Form.Group className='mb-3'>
                            {/*<Form.Label className="label-custom">Nombre</Form.Label>*/}
                            <Form.Select value={hourSelected} onChange={(e) => handleOnChangeHour(e.target.value)}>
                              <option value={"-1"}>Elige un Horario disponible</option>
                              {availableHours.map((item) => (
                                <option value={item}>{item}</option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                          {/*hours.map((item, index) => {
                            return <Col md={ 6 } className='hour-cols'>
                              <Button type='button' className='hour-group' id={'hour_' + index} onClick={ () => handleOnChangeHour(index)}>
                                { item }
                              </Button>
                            </Col>
                          })*/}

                          <Container>
                            <Row>
                              <Col md={6}>
                                <Form.Group className='mb-3'>
                                  {/*<Form.Label className="label-custom">Nombre</Form.Label>*/}
                                  <Form.Control required name="name" value={name} placeholder='Nombre' onChange={(e) => setName(e.target.value)} />
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className='mb-3'>
                                  {/*<Form.Label className="label-custom">Apellidos</Form.Label>*/}
                                  <Form.Control required name="lastName" value={lastName} placeholder='Apellidos' onChange={(e) => setLastName(e.target.value)} />
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className='mb-3'>
                                  {/*<Form.Label className="label-custom">Correo Electrónico</Form.Label>*/}
                                  <Form.Control required type="email" value={email} name="email" placeholder='Correo Electrónico' onChange={(e) => setEmail(e.target.value)} />
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className='mb-3'>
                                  {/*<Form.Label className="label-custom">Teléfono</Form.Label>*/}
                                  <Form.Control required type="number" value={phone} name="phone" placeholder='Teléfono' onChange={(e) => setPhone(e.target.value)} />
                                </Form.Group>
                              </Col>
                              <Col md={12}>
                                <Form.Group className='mb-3'>
                                  {/*<Form.Label className="label-custom">Mensaje</Form.Label>*/}
                                  <Form.Control required name="comments" as="textarea" value={comments} rows="2" placeholder='Mensaje' onChange={(e) => setComments(e.target.value)} />
                                </Form.Group>
                              </Col>
                            </Row>
                          </Container>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                </Container>
              </Form.Group>

              {/*<Row>
                <Col md={ 6 }>
                  <Form.Group>
                    <Form.Label className="label-custom">Fecha</Form.Label>
                    <Form.Control required disabled name="startDate" value={prettyFormat(startDate)} />
                  </Form.Group>
                </Col>
                <Col md={ 6 }>
                  <Form.Group>
                    <Form.Label className="label-custom">Horario</Form.Label>
                    <Form.Control required disabled value={hour} />
                  </Form.Group>
                </Col>
              </Row>*/}

            </Container>

            <div align="center">
              <br />
              <Button className='calendar-submit' disabled={isLoading} style={{ borderRadius: 0 }} type="submit">
                <Spinner
                  className={isLoading ? '' : 'hide'}
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span>{isLoading ? 'ENVIANDO…' : 'ENVIAR'}</span>
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      <Modal show={showPrivacy} size="lg" onHide={() => setShowPrivacy(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#000", paddingLeft: "34px" }}>AVISO DE PRIVACIDAD</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", textAlign: "justify" }}>
          MARIBEL TORRES RIOS, mejor conocido como GRUPO OPTICO JARDINES, con domicilio en calle ANDADOR
          PARIS 34, PISO 6, colonia CENTRO URBANO, ciudad CUAUTITLAN IZCALLI, municipio o delegación CUAUTITLAN
          IZCALLI, c.p. 54700, en la entidad de ESTADO DE MEXICO, país MEXICO, y portal de internet
          https://grupoopticojardines.com.mx/, es el responsable del uso y protección de sus datos personales, y al
          respecto le informamos lo siguiente:
          <br /><br />
          ¿Para qué fines utilizaremos sus datos personales?
          Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades que son necesarias
          para el servicio que solicita:
          l Para la creación, estudio, análisis, actualización, y conservación del expediente clinico
          De manera adicional, utilizaremos su información personal para las siguientes finalidades secundarias que no son
          necesarias para el servicio solicitado, pero que nos permiten y facilitan brindarle una mejor atención:
          l Mercadotecnia o publicitaria
          l Prospección comercial
          En caso de que no desee que sus datos personales se utilicen para estos fines secundarios, indíquelo a continuación:
          No consiento que mis datos personales se utilicen para los siguientes fines:
          [ ] Mercadotecnia o publicitaria
          [ ] Prospección comercial
          La negativa para el uso de sus datos personales para estas finalidades no podrá ser un motivo para que le neguemos
          los servicios y productos que solicita o contrata con nosotros.
          ¿Qué datos personales utilizaremos para estos fines?
          Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, utilizaremos los siguientes datos
          personales:
          l Datos de identificación
          l Datos de contacto
          l Datos sobre características físicas
          l Datos laborales
          Además de los datos personales mencionados anteriormente, para las finalidades informadas en el presente aviso de
          privacidad utilizaremos los siguientes datos personales considerados como sensibles, que requieren de especial
          protección:
          l Datos de salud
          ¿Cómo puede acceder, rectificar o cancelar sus datos personales, u oponerse a su uso?
          Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del
          uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de
          que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases
          de datos cuando considere que la misma no está siendo utilizada adecuadamente (Cancelación); así como oponerse
          al uso de sus datos personales para fines específicos (Oposición). Estos derechos se conocen como derechos
          ARCO.
          Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva a través del
          siguiente medio:
          Enviando un correo electronico a lab.optico.jardines@gmail.com
          <br /><br />
          Para conocer el procedimiento y requisitos para el ejercicio de los derechos ARCO, ponemos a su disposición el
          siguiente medio:
          Enviando un correo electronico a lab.optico.jardines@gmail.com
          Los datos de contacto de la persona o departamento de datos personales, que está a cargo de dar trámite a las
          solicitudes de derechos ARCO, son los siguientes:
          a) Nombre de la persona o departamento de datos personales: Maribel Torres Rios
          b) Domicilio: calle Andador Paris 34, piso 6, colonia Centro Urbano, ciudad Cuautitlan Izcalli, municipio o delegación
          Cuautitlan Izcalli, c.p. 54700, en la entidad de Estado de Mexico, país Mexico
          c) Correo electrónico: lab.optico.jardines@gmail.com
          d) Número telefónico: 5581912834
          Usted puede revocar su consentimiento para el uso de sus datos personales
          Usted puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento de sus datos
          personales. Sin embargo, es importante que tenga en cuenta que no en todos los casos podremos atender su
          solicitud o concluir el uso de forma inmediata, ya que es posible que por alguna obligación legal requiramos seguir
          tratando sus datos personales. Asimismo, usted deberá considerar que para ciertos fines, la revocación de su
          consentimiento implicará que no le podamos seguir prestando el servicio que nos solicitó, o la conclusión de su
          relación con nosotros.
          Para revocar su consentimiento deberá presentar su solicitud a través del siguiente medio:
          Enviando un correo electronico a lab.optico.jardines@gmail.com
          Para conocer el procedimiento y requisitos para la revocación del consentimiento, ponemos a su disposición el
          siguiente medio:
          enviando un coreo lab.optico.jardines@gmail.com
          ¿Cómo puede limitar el uso o divulgación de su información personal?
          Con objeto de que usted pueda limitar el uso y divulgación de su información personal, le ofrecemos los siguientes
          medios:
          Enviando un correo a lab.optico.jardines@gmail.com
          ¿Cómo puede conocer los cambios en este aviso de privacidad?
          El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos
          requerimientos legales; de nuestras propias necesidades por los productos o servicios que ofrecemos; de nuestras
          prácticas de privacidad; de cambios en nuestro modelo de negocio, o por otras causas.
          Nos comprometemos a mantenerlo informado sobre los cambios que pueda sufrir el presente aviso de privacidad, a
          través de: Seran redactados en la pagina de internet.
          El procedimiento a través del cual se llevarán a cabo las notificaciones sobre cambios o actualizaciones al presente
          aviso de privacidad es el siguiente:
          Seran dados a conocer en la pagina de Internet
          Última actualización: 03/10/2020
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPrivacy(false)}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPolicy} size="lg" onHide={() => setShowPolicy(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#000", paddingLeft: "34px" }}>POLÍTICAS DE GARANTÍA</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", textAlign: "justify" }}>
          <div align="center"><img src={policy} width="80%" /></div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPolicy(false)}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <Navbar id="rensa-navbar" collapseOnSelect expand="lg" variant="light" className="nav-bar-custom-start" fixed="top">
        <Container>
          <Navbar.Brand href="#home">
            <img alt="" id="brand_image" src={logo} width="auto" height="30" className="d-inline-block align-top brand-image-start" onClick={() => handleNavClick("refHome")} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto" onSelect={handleNavClick}>
              <Nav.Link eventKey="refHome">
                <div className="nav-link-custom">HOME</div>
              </Nav.Link>
              <Nav.Link eventKey="refServices">
                <div className="nav-link-custom">SERVICIOS</div>
              </Nav.Link>
              <Nav.Link eventKey="refFundation">
                <div className="nav-link-custom">FUNDACIÓN</div>
              </Nav.Link>
              {/*<Nav.Link>
                <div className="nav-link-custom" onClick={ () => { setShowDates(true); gettingDayAvailable() } }>CITAS</div>
              </Nav.Link>*/}
            </Nav>
            <Nav className='align-items-center' onSelect={handleNavClick}>
              <Nav.Link eventKey="refContact">
                <div className="nav-link-custom">SUCURSALES</div>
              </Nav.Link>
              <Nav.Link className="nav-link-custom" onClick={() => window.open('https://wa.me/5215621397439')}>
                <Whatsapp className="icons-style" />&nbsp;&nbsp;
                56 2139 7439
              </Nav.Link>
              <Nav.Link className="nav-link-custom" onClick={() => { setShowDates(true); gettingDayAvailable() }}>
                <div className='header-date'>
                  <Calendar className="icons-style" />&nbsp;&nbsp;
                  <span className=''>AGENDA TU CITA</span>
                </div>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div ref={refHome}>
        <Container className='home-banner'>
          <Carousel className="home-carousel" pause={false}>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={home0}
                alt="Estilo"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={home1}
                alt="Bifocales"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={home2}
                alt="Armazones"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={home3}
                alt="Clinica"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={home4}
                alt="Lentes para niños"
              />
            </Carousel.Item>
          </Carousel>
        </Container>
      </div>

      {/*<Container className='clients-container'>
        <div>
          <Marquee velocity={10} autoFill={true} gradient={true}>
            {photos.map((id, idx) => (
              <img loading='lazy' alt="Marcas" className="styled-img" src={id} key={`marquee-example-people-${idx}`} style={{ marginLeft: "87px" }} width="300px" height="188px" />
            ))}
          </Marquee>
        </div>
      </Container>*/}

      <div ref={refServices} className='section section_gray'>
        <Container>
          <Row className="align-items-center">
            <Col md={4}>
              <div className='heading-title_alt'>
                <div>Conoce un poco de nosotros,</div>
                <div>somos la mejor opción</div>
              </div>
              <div align="right"><div className='line-title' /></div>
            </Col>
            <Col md={8}>
              <div className="heading-desc">
                <div>Somos especialistas de atención primaria en salud ocular, con un grupo de optometristas de primer nivel, que van a garantizar la mejor atención para determinar cuál es la mejor solución que se adapte a sus necesidades.</div>
                <div><b>Contamos con:</b></div>
              </div>
              <br />
              <Container>
                <Row>
                  <Col md={4} className='service-col'>
                    <div>
                      <div align='center'>
                        <span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" class="service-icon" height="100" viewBox="0 0 512 512" width="100"><g><path d="m121 451c66.168 0 120-53.832 120-120 0-8.271 6.729-15 15-15s15 6.729 15 15c0 66.168 53.832 120 120 120 66.72 0 121-53.832 121-120 0-27.636-9.474-53.115-25.363-73.424l20.969-20.969-21.213-21.213-21.018 21.018c-4.241-3.287-8.71-6.297-13.375-9.009v-31.403c0-8.271 6.729-15 15-15h15v-30h-183.58c-4.527-12.764-14.656-22.893-27.42-27.42v-32.58h30v-30h-90v30h30v32.58c-12.764 4.527-22.893 14.656-27.42 27.42h-183.58v30h15c8.271 0 15 6.729 15 15v31.402c-4.666 2.712-9.134 5.722-13.375 9.009l-21.018-21.018-21.213 21.213 20.969 20.969c-15.889 20.31-25.363 45.789-25.363 73.425 0 66.168 54.28 120 121 120zm361-120c0 49.626-40.822 90-91 90-49.626 0-90-40.374-90-90s40.374-90 90-90c50.178 0 91 40.374 91 90zm-60-135v18.999c-9.898-2.604-20.287-3.999-31-3.999-10.355 0-20.408 1.319-30 3.797v-18.797c0-5.258-.915-10.305-2.58-15.01h66.151c-1.665 4.703-2.571 9.753-2.571 15.01zm-166-45c8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15 6.729-15 15-15zm-42.42 30c4.527 12.764 14.656 22.893 27.42 27.42v32.58h30v-32.58c12.764-4.527 22.893-14.656 27.42-27.42h17.58c8.271 0 15 6.729 15 15v31.109c-24.677 14.307-43.81 37.152-53.338 64.463-6.431-3.548-13.813-5.572-21.662-5.572s-15.231 2.024-21.662 5.572c-9.528-27.311-28.661-50.156-53.338-64.463v-31.109c0-8.271 6.729-15 15-15zm-126.15-.01h66.151c-1.665 4.705-2.58 9.751-2.58 15.01v18.797c-9.592-2.478-19.645-3.797-30-3.797-10.713 0-21.102 1.395-31 3.999v-18.999c-.001-5.257-.907-10.307-2.571-15.01zm33.57 60.01c49.626 0 90 40.374 90 90s-40.374 90-90 90c-50.178 0-91-40.374-91-90s40.822-90 91-90z"></path><path d="m121 391c33.084 0 60-26.916 60-60s-26.916-60-60-60c-33.087 0-61 26.822-61 60 0 33.212 27.953 60 61 60zm0-90c16.542 0 30 13.458 30 30s-13.458 30-30 30c-16.804 0-31-13.738-31-30s14.196-30 31-30z"></path><path d="m331 331c0 33.084 26.916 60 60 60 33.087 0 61-26.822 61-60 0-33.212-27.953-60-61-60-33.084 0-60 26.916-60 60zm91 0c0 16.262-14.196 30-31 30-16.542 0-30-13.458-30-30s13.458-30 30-30c16.804 0 31 13.738 31 30z"></path></g></svg></span>
                      </div>
                      <div className='service-item'> Diagnósticos Integrales </div>
                    </div>
                  </Col>
                  <Col md={4} className='service-col'>
                    <div>
                      <div align='center'>
                        <span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" class="service-icon" height="100" viewBox="0 0 512 512" width="100"><g><path d="m477.996 359.691c-4.142 0-7.5 3.358-7.5 7.5v90.858c0 21.477-17.473 38.95-38.951 38.95h-351.091c-21.477 0-38.95-17.473-38.95-38.95v-277.261c0-4.142-3.357-7.5-7.5-7.5-4.142 0-7.5 3.358-7.5 7.5v277.262c0 29.748 24.202 53.95 53.95 53.95h351.091c29.749 0 53.951-24.202 53.951-53.95v-90.858c0-4.143-3.358-7.501-7.5-7.501z"></path><path d="m431.545 0h-351.091c-29.748 0-53.95 24.202-53.95 53.951v96.837c0 4.142 3.358 7.5 7.5 7.5 4.143 0 7.5-3.358 7.5-7.5v-96.837c0-21.478 17.473-38.951 38.95-38.951h351.091c21.478 0 38.951 17.473 38.951 38.951v283.241c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-283.241c0-29.749-24.202-53.951-53.951-53.951z"></path><path d="m274.243 64.66c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-36.486c-4.143 0-7.5 3.358-7.5 7.5v86.591c0 4.142 3.357 7.5 7.5 7.5h36.486c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-28.986v-28.296h26.295c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-26.295v-28.295z"></path><path d="m192.879 166.847h-29.958c-4.143 0-7.5 3.358-7.5 7.5v73.916c0 4.142 3.357 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-30.158h20.078c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-20.078v-21.258h22.458c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"></path><path d="m327.655 166.302h-20.733c-4.096 0-7.5 3.323-7.5 7.5v74.461c0 4.142 3.357 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-24.884c4.584-.025 10.185-.051 13.233-.051 15.949 0 28.924-12.791 28.924-28.513s-12.976-28.513-28.924-28.513zm0 42.026c-3.026 0-8.557.025-13.131.05-.025-4.71-.051-10.461-.051-13.563 0-2.612-.016-8.593-.029-13.513h13.211c7.548 0 13.924 6.188 13.924 13.513s-6.376 13.513-13.924 13.513z"></path><path d="m385.461 288.133h-32.785c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h18.947l-26.296 40.358c-3.247 4.983.338 11.594 6.284 11.594h34.658c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-20.82l26.296-40.358c3.246-4.982-.34-11.594-6.284-11.594z"></path><path d="m125.732 288.133c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h6.788v44.452c0 4.142 3.357 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5v-44.452h6.903c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"></path><path d="m254.508 355.085c18.459 0 33.476-15.017 33.476-33.476s-15.017-33.476-33.476-33.476-33.476 15.017-33.476 33.476 15.017 33.476 33.476 33.476zm0-51.952c10.188 0 18.476 8.288 18.476 18.476s-8.289 18.476-18.476 18.476-18.476-8.288-18.476-18.476 8.289-18.476 18.476-18.476z"></path><path d="m105.951 402.058c-4.142 0-7.5 3.358-7.5 7.5v45.219c0 3.655 2.635 6.777 6.237 7.393 1.409.24 11.275.14 17.152.107 4.142-.023 7.481-3.4 7.458-7.542s-3.408-7.503-7.542-7.458c-2.803.016-5.747.028-8.306.034v-37.752c.001-4.143-3.357-7.501-7.499-7.501z"></path><path d="m281.652 409.971v44.844c0 4.142 3.358 7.5 7.5 7.5h18.896c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-11.396v-7.422h10.002c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-10.002v-7.422h11.396c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-18.896c-4.142 0-7.5 3.358-7.5 7.5z"></path><path d="m368.493 455.388c.303 3.952 3.588 6.927 7.471 6.927 1.385 0 9.863-.046 12.845-.098 14.335-.251 24.74-12.6 24.74-29.362 0-17.62-10.141-29.459-25.236-29.459h-12.438c-1.992 0-3.901.792-5.308 2.202-2.262 2.265-2.09 4.859-2.191 5.344.047 45.901-.108 43.142.117 44.446zm19.821-36.992c9.498 0 10.236 11.067 10.236 14.459 0 7.063-3.093 14.243-10.002 14.364-1.219.021-3.134.04-5.108.054-.046-14.913-.02-10.503-.051-28.876h4.925z"></path><path d="m206.027 402.058h-12.602c-4.12 0-7.5 3.355-7.5 7.5v45.257c0 4.142 3.358 7.5 7.5 7.5 4.143 0 7.5-3.358 7.5-7.5v-12.198c1.96-.009 3.874-.016 5.102-.016 11.316 0 20.521-9.094 20.521-20.271s-9.205-20.272-20.521-20.272zm0 25.543c-1.22 0-3.108.007-5.054.016-.009-2.035-.021-8.418-.026-10.559h5.08c2.993 0 5.521 2.414 5.521 5.271s-2.528 5.272-5.521 5.272z"></path></g></svg></span>
                      </div>
                      <div className='service-item'> Examen visual avanzado </div>
                      <div className='service-item-desc'> Problemas acomodativos y binoculares </div>
                    </div>
                  </Col>
                  <Col md={4} className='service-col'>
                    <div>
                      <div align='center'>
                        <span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" class="service-icon" height="100" viewBox="0 0 512 512" width="100"><g><g><g><path d="m361.193 282.347h-210.427c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h210.428c4.143 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.501-7.5z"></path><path d="m361.193 316.512h-210.427c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h210.428c4.143 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.501-7.5z"></path><path d="m361.193 350.677h-210.427c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h210.428c4.143 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.501-7.5z"></path><path d="m255.98 384.842h-105.214c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h105.214c4.143 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"></path><path d="m429.431 49.19h-98.458v-3.843c0-8.181-6.655-14.836-14.836-14.836h-32.317v-2.183c0-15.084-12.037-27.784-26.832-28.31-7.636-.271-14.854 2.494-20.34 7.788-5.487 5.295-8.509 12.411-8.509 20.035v2.67h-32.317c-8.181 0-14.836 6.655-14.836 14.836v3.843h-98.459c-11.121 0-20.168 9.047-20.168 20.167v422.434c0 11.12 9.047 20.167 20.168 20.167h346.903c11.121 0 20.168-9.047 20.168-20.167v-422.434c.001-11.12-9.046-20.167-20.167-20.167zm5.168 442.601c0 2.849-2.318 5.167-5.168 5.167h-346.904c-2.85 0-5.168-2.318-5.168-5.167v-422.434c0-2.849 2.318-5.167 5.168-5.167h19.621v388.954c0 11.003 8.952 19.955 19.955 19.955h225.309c3.31.015 5.017-1.896 7.066-4.024 2.321-2.411 52.055-53.873 53.236-55.3 1.241-1.5 2.096-3.201 2.096-5.2 0-.048 0-99.096 0-99.096 0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v91.596h-33.098c-12.02 0-21.798 9.779-21.798 21.798v35.226h-217.81c-2.732 0-4.955-2.223-4.955-4.955v-388.954h63.837v9.94c0 8.181 6.655 14.836 14.836 14.836h15.658c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-15.494v-28.455h32.309c5.712 0 11.406-3.837 13.789-8.991 2.849-6.162-.635-12.5 4.981-17.921 4.735-4.57 13.221-4.479 18.115-.299 6.158 5.258 1.913 14.159 6.059 20.489 2.72 4.152 7.447 6.721 12.417 6.722h32.316v28.455h-69.91c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h70.074c8.181 0 14.836-6.655 14.836-14.836v-9.94h63.837v210.29c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-210.29h19.621c2.85 0 5.168 2.318 5.168 5.167v422.434zm-79.685-44.798v-24.121c0-3.749 3.05-6.798 6.798-6.798h22.967l-26.409 27.433z"></path><path d="m259.749 129.521c-20.943-.872-42.542 5.042-60.928 14.035-15.122 7.397-29.021 17.228-41.417 28.592-5.574 5.11-10.881 10.537-15.752 16.324-3.824 4.543-3.824 11.14 0 15.683 7.548 8.967 16.101 17.131 25.234 24.466 7.471 6 15.401 11.442 23.751 16.147 17.158 9.668 36.175 16.187 55.94 18.008 22.023 2.028 44.52-3.32 64.44-12.687 15.399-7.242 29.562-17.025 42.198-28.394 6.069-5.459 11.832-11.292 17.09-17.54 3.824-4.543 3.824-11.139 0-15.682-11.972-14.223-26.364-26.627-42.083-36.491-20.516-12.874-44.145-21.449-68.473-22.461zm20.887 25.603c9.46 0 17.156 7.696 17.156 17.156s-7.696 17.156-17.156 17.156-17.156-7.696-17.156-17.156 7.696-17.156 17.156-17.156zm-125.948 41.19c7.224-8.277 23.034-24.432 45.324-36.528-6.882 10.509-10.901 23.055-10.901 36.527 0 13.473 4.019 26.019 10.901 36.528-22.29-12.095-38.1-28.25-45.324-36.527zm104.755 51.74c-2.185.145-4.72.142-6.927 0-26.99-1.79-48.405-24.305-48.405-51.74 0-18.958 10.727-36.769 27.423-45.725 8.34-4.474 18.483-6.639 27.91-6.015 1.407.093 2.802.235 4.177.439-9.084 5.689-15.141 15.781-15.141 27.267 0 17.731 14.425 32.156 32.156 32.156 11.186 0 21.052-5.744 26.814-14.435.253 2.071.398 4.174.398 6.312 0 27.436-21.415 49.951-48.405 51.741zm52.504-15.212c6.882-10.509 10.901-23.055 10.901-36.528s-4.019-26.019-10.901-36.528c22.29 12.096 38.1 28.251 45.324 36.528-7.225 8.277-23.035 24.432-45.324 36.528z"></path></g></g></g></svg></span>
                      </div>
                      <div className='service-item'> Manejo de patologías </div>
                      <div className='service-item-desc'> Segmento anterior como conjuntivitis, beflaritis, etc. </div>
                    </div>
                  </Col>
                  <Col md={4} className='service-col'>
                    <div>
                      <div align='center'>
                        <span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" class="service-icon" height="100" viewBox="0 0 512 512" width="100"><g><path d="m497.976 431.215c-.385-.385-146.356-146.356-147.863-147.863-1.385-1.385-2.499-2.616-4.502-3.204-.042-.012-37.468-10.989-37.468-10.989l-21.921-21.921c9.228-13.248 16.192-27.606 20.876-42.533 8.301 1.551 16.901 2.576 25.777 2.98 3.872.176 7.815.233 11.689.001 86.252-3.897 146.218-67.325 162.807-87.036 4.552-5.413 4.552-13.268-.001-18.682-4.73-5.62-12.677-14.425-23.675-24.459-3.056-2.786-7.793-2.571-10.582.486-2.787 3.056-2.571 7.793.486 10.582 10.198 9.304 17.586 17.449 22.053 22.734-11.083 13.112-41.598 45.628-85.98 65.427 15.89-17.217 25.615-40.207 25.615-65.428 0-25.19-9.7-48.154-25.556-65.364 12.654 5.674 25.155 12.82 37.457 21.436 3.39 2.378 8.059 1.551 10.432-1.837s1.55-8.058-1.838-10.431c-17.375-12.17-36.223-22.331-56.257-29.38-21.071-7.415-43.945-11.795-66.345-10.817-28.95 1.263-54.942 9.236-77.335 20.025-61.695-49.795-152.565-46.054-209.861 11.242-61.312 61.313-61.312 161.074 0 222.387 30.656 30.656 70.925 45.983 111.193 45.983 31.489 0 62.979-9.374 89.872-28.12 0 0 22.655 22.655 22.655 22.655 1.041 3.55 9.576 32.65 10.091 34.405.559 1.906 1.004 3.653 2.451 5.1l71.4 71.4c2.926 2.924 7.667 2.924 10.593 0 2.925-2.926 2.925-7.667 0-10.593l-66.104-66.103 45.37-45.369 143.879 143.88c12.508 12.508 12.508 32.86.001 45.368-12.51 12.51-32.863 12.508-45.37 0l-53.325-53.324c-2.926-2.924-7.667-2.924-10.593 0-2.925 2.926-2.925 7.667 0 10.593l53.325 53.325c9.175 9.174 21.225 13.761 33.276 13.761s24.103-4.588 33.278-13.762c18.348-18.351 18.348-48.206 0-66.555zm-187.75-121.195-19.052 19.052-6.384-21.772 22.717-22.717 21.771 6.385zm94.995-234.767c0 16.266-13.234 29.5-29.501 29.5-16.266 0-29.5-13.234-29.5-29.5 0-16.267 13.234-29.501 29.5-29.501 16.267-.001 29.501 13.233 29.501 29.501zm-29.501 44.48c5.034 0 9.869-.853 14.385-2.401-2.995 25.699-24.885 45.714-51.375 45.714-28.528 0-51.738-23.21-51.738-51.738 0-26.937 20.697-49.121 47.022-51.512-1.791 4.817-2.774 10.024-2.774 15.457 0 24.526 19.953 44.48 44.48 44.48zm-41.603-89.864c9.33-.392 18.595.682 27.438 3.229-7.002 2.359-13.226 6.413-18.188 11.677-1.534-.109-3.076-.183-4.637-.183-36.788 0-66.718 29.929-66.718 66.717s29.929 66.718 66.718 66.718c36.787 0 66.717-29.929 66.717-66.718 0-.984-.032-1.961-.078-2.934 5.432-4.867 9.665-11.045 12.193-18.034 1.817 6.833 2.745 13.896 2.745 20.968 0 43.436-34.125 79.043-76.973 81.441-3.132.175-6.077.175-9.21 0-42.847-2.397-76.974-38.004-76.974-81.441.001-43.434 34.123-79.038 76.967-81.44zm-66.331 16.013c-15.89 17.217-25.615 40.206-25.615 65.427 0 25.222 9.724 48.211 25.615 65.428-44.384-19.799-74.897-52.316-85.98-65.428 11.083-13.113 41.596-45.629 85.98-65.427zm-97.697 74.768c11.141 13.238 41.85 46.203 86.951 67.605-4.845 15.765-13.476 30.607-25.927 43.059-19.749 19.749-46.006 30.625-73.936 30.625s-54.187-10.877-73.935-30.626c-40.768-40.767-40.768-107.103 0-147.87 19.749-19.75 46.006-30.626 73.935-30.626 17.89 0 35.086 4.476 50.333 12.876-18.242 14.643-31.04 28.694-37.42 36.275-4.556 5.412-4.556 13.27-.001 18.682zm-113.512 137.328c-26.872-26.871-41.671-62.598-41.671-100.601 0-38.001 14.799-73.729 41.671-100.6 27.735-27.736 64.167-41.604 100.6-41.604 29.582 0 59.16 9.15 84.086 27.437-7.432 4.25-14.378 8.749-20.818 13.317-18.795-11.772-40.542-18.09-63.268-18.09-31.931 0-61.95 12.435-84.529 35.012-46.608 46.609-46.608 122.447 0 169.056 22.579 22.578 52.598 35.013 84.529 35.013s61.95-12.436 84.529-35.013c13.824-13.824 23.534-30.223 29.158-47.665 6.932 2.721 14.156 5.133 21.654 7.145-6.837 21.106-18.599 40.451-34.74 56.592-55.472 55.473-145.731 55.473-201.201.001zm211.793 10.593c3.031-3.031 5.896-6.164 8.626-9.374l17.355 17.355-18 18-17.347-17.347c3.209-2.73 6.336-5.604 9.366-8.634z"></path></g></svg></span>
                      </div>
                      <div className='service-item'> Exploración de segmento posterior, revisión de fondo de ojo </div>
                    </div>
                  </Col>
                  <Col md={4} className='service-col'>
                    <div>
                      <div align='center'>
                        <span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" class="service-icon" height="100" viewBox="0 0 50 50" width="100"><path d="m.025 32.188c.014.071.047.135.076.202.02.045.023.094.051.137.006.01.016.017.021.026.013.019.029.034.043.052.065.083.14.154.224.211.013.008.019.021.031.029l24.844 15.5c.165.103.348.151.528.151.334 0 .66-.167.85-.471.292-.469.149-1.085-.319-1.378l-1.634-1.019c1.728-1.492 3.143-3.289 4.186-5.279.027-.038.045-.081.066-.123.51-.989.927-2.024 1.246-3.093.004-.016.014-.028.016-.045 0-.003-.001-.006 0-.009.39-1.32.633-2.688.711-4.08h5.03c.553 0 1-.448 1-1s-.447-1-1-1h-5.03c-.078-1.395-.321-2.765-.713-4.086 0-.004.002-.007.001-.011-.002-.016-.013-.027-.015-.042-.329-1.097-.763-2.159-1.291-3.173-.015-.023-.022-.051-.039-.072-1.042-1.978-2.45-3.763-4.168-5.247l1.635-1.02c.469-.292.611-.909.319-1.378-.292-.468-.907-.611-1.378-.319l-2.8 1.749c-.01.006-.019.012-.029.018l-22.015 13.731c-.009.005-.013.014-.021.019-.055.036-.097.089-.144.136-.048.047-.101.089-.137.145-.005.008-.014.012-.019.02-.027.043-.031.092-.051.137-.029.067-.063.131-.076.202-.013.064-.007.126-.007.19s-.004.127.008.19zm27.935-5.824c-2.321.847-3.962 3.087-3.962 5.634s1.641 4.788 3.963 5.635c-.116.31-.244.614-.379.915-2.729-1.001-4.584-3.578-4.584-6.55 0-2.971 1.854-5.547 4.582-6.549.136.301.263.606.38.915zm1.003 6.631c-.059.923-.196 1.833-.41 2.722-1.5-.589-2.555-2.053-2.555-3.719s1.055-3.129 2.554-3.718c.215.891.353 1.804.411 2.729-.537.018-.968.453-.968.994 0 .539.431.974.968.992zm-2.332-9.341c-3.371 1.353-5.633 4.615-5.633 8.344s2.263 6.992 5.635 8.344c-.966 1.581-2.204 2.998-3.678 4.174l-20.064-12.518 20.064-12.515c1.473 1.176 2.711 2.592 3.676 4.171z"></path><path d="m38.551 33.895 3.447 1.726v.382c0 .553.447 1 1 1h20.001c.553 0 1-.447 1-1v-8c0-.552-.447-1-1-1h-20.001c-.553 0-1 .448-1 1v.383l-3.447 1.725c-.339.169-.553.516-.553.894v1.995c0 .379.214.725.553.895zm23.448-4.893v6h-18.001v-6zm-22.001 2.62 2-1.001v2.762l-2-1z"></path><path d="m55.993 39h-9c-.553 0-1 .447-1 1s.447 1 1 1h9c.553 0 1-.447 1-1s-.447-1-1-1z"></path><path d="m46.993 25h9c.553 0 1-.448 1-1s-.447-1-1-1h-9c-.553 0-1 .448-1 1s.447 1 1 1z"></path><path d="m50.996 21h9c.553 0 1-.448 1-1s-.447-1-1-1h-9c-.553 0-1 .448-1 1s.447 1 1 1z"></path><path d="m49.997 44c0 .553.447 1 1 1h9c.553 0 1-.447 1-1s-.447-1-1-1h-9c-.553 0-1 .447-1 1z"></path></svg></span>
                      </div>
                      <div className='service-item'> Control y seguimiento de la presión intraocular </div>
                    </div>
                  </Col>
                  <Col md={4} className='service-col'>
                    <div>
                      <div align='center'>
                        <span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" class="service-icon" height="100" viewBox="0 0 512 512" width="100"><g><g><path d="m481.417 280.04c11.977-11.974 20.939-22.344 26.557-29.239 5.566-6.831 5.566-16.747 0-23.577-25.344-31.11-118.405-132.761-251.791-134.696-.072-.001-.145-.001-.217 0-133.386 1.935-226.446 103.586-251.791 134.695-5.566 6.831-5.566 16.747 0 23.577 25.345 31.109 118.405 132.761 251.791 134.695.036 0 .072.001.108.001s.072 0 .108-.001c38.024-.551 72.757-9.222 103.592-22.037 9.366 32.409 39.283 56.186 74.668 56.186 42.86 0 77.729-34.869 77.729-77.729.001-25.221-12.082-47.665-30.754-61.875zm-124.419 68.261c-33.112 14.224-66.873 21.685-100.923 22.194-54.369-.812-108.008-19.263-159.428-54.841-41.968-29.039-70.517-61.654-80.843-74.329-1.093-1.34-1.093-3.286 0-4.627 10.326-12.675 38.875-45.29 80.843-74.328 51.42-35.578 105.059-54.029 159.428-54.841 54.369.812 108.009 19.263 159.429 54.841 41.968 29.038 70.517 61.653 80.843 74.329 1.093 1.34 1.093 3.286 0 4.627-5.104 6.266-14.694 17.419-28.13 30.591-7.078-3.429-14.756-5.801-22.824-6.944 6.115-6.287 10.891-11.696 14.214-15.646 5.03-5.978 5.029-14.654-.001-20.63-20.032-23.803-92.447-100.411-196.538-105.107-4.783-.216-9.213-.215-13.987 0-104.087 4.696-176.504 81.303-196.537 105.107-5.029 5.977-5.029 14.653 0 20.631 20.035 23.805 92.466 100.426 196.568 105.108 4.705.212 9.2.213 13.926 0 35.53-1.598 67.362-11.582 94.689-24.98-.657 4.059-1.012 8.218-1.012 12.46-.001 2.151.11 4.277.283 6.385zm-201.562-109.289c0-53.434 41.861-97.268 94.51-100.448 4.101-.247 8.148-.248 12.258 0 9.522.575 18.688 2.486 27.32 5.537-10.634 2.383-20.06 7.996-27.177 15.765-2.07-.168-4.159-.263-6.271-.263-8.081 0-16.057 1.211-23.705 3.601-3.954 1.235-6.157 5.441-4.923 9.395 1.235 3.954 5.441 6.158 9.396 4.922 5.156-1.611 10.501-2.55 15.929-2.825-2.698 6.311-4.196 13.252-4.196 20.538 0 28.899 23.512 52.411 52.412 52.411 6.81 0 13.314-1.32 19.289-3.694-2.534 33.213-30.349 59.469-64.201 59.469-35.515 0-64.408-28.894-64.408-64.409 0-17.18 6.683-33.338 18.817-45.497 2.926-2.932 2.921-7.681-.011-10.606-2.932-2.927-7.681-2.922-10.606.011-14.961 14.991-23.2 34.912-23.2 56.093 0 43.786 35.622 79.409 79.408 79.409s79.409-35.623 79.409-79.409c0-1.429-.053-2.846-.132-4.256 7.962-6.932 13.821-16.216 16.469-26.767 3.175 9.776 4.893 20.203 4.893 31.023 0 53.434-41.861 97.268-94.51 100.447-4.102.248-8.165.247-12.259 0-52.651-3.18-94.511-47.013-94.511-100.447zm21.329 84.076c-58.679-23.898-98.891-66.958-112.745-83.419-.341-.405-.341-.909 0-1.313 13.854-16.462 54.067-59.522 112.746-83.42-22.354 21.099-36.33 50.985-36.33 84.076 0 33.092 13.975 62.977 36.329 84.076zm124.221-90.442c-20.629 0-37.412-16.783-37.412-37.411 0-20.629 16.783-37.412 37.412-37.412s37.411 16.783 37.411 37.412c0 20.628-16.782 37.411-37.411 37.411zm34.397 90.442c22.355-21.099 36.331-50.984 36.331-84.076s-13.976-62.979-36.332-84.077c58.681 23.898 98.893 66.959 112.748 83.421.341.405.341.908 0 1.313-4.868 5.784-13.011 14.861-24.05 25.229-26.741 3.58-49.211 20.797-60.172 44.415-8.939 5-18.453 9.673-28.525 13.775zm99.059 81.556c-34.589 0-62.729-28.14-62.729-62.729s28.14-62.729 62.729-62.729 62.729 28.14 62.729 62.729-28.14 62.729-62.729 62.729z"></path><path d="m476.111 308.641c-6.012-6.012-15.068-7.937-22.976-4.941-2.856 1.082-5.461 2.782-7.62 4.941-.006.006-20.223 20.223-20.223 20.223l-1.936-1.935c-8.431-8.432-22.152-8.433-30.585 0-4.088 4.088-6.338 9.522-6.335 15.304.002 5.781 2.258 11.214 6.35 15.298l18.033 17.997c3.999 3.991 9.249 5.986 14.5 5.986 9.043 0 14.355-5.841 20.225-11.71 2.929-2.929 2.929-7.678 0-10.606-2.93-2.929-7.678-2.929-10.607 0l-5.709 5.709c-2.152 2.151-5.656 2.155-7.813.004l-18.033-17.997c-2.541-2.537-2.552-6.831-.005-9.378 2.584-2.584 6.788-2.586 9.374 0l7.238 7.238c2.928 2.929 7.677 2.928 10.606 0 0 0 25.507-25.507 25.526-25.526 2.449-2.449 6.938-2.444 9.382 0 2.587 2.587 2.587 6.796 0 9.383l-5.942 5.942c-2.929 2.929-2.929 7.678 0 10.606 2.93 2.929 7.678 2.929 10.608-.001 4.865-4.866 10.177-9.469 11.745-16.495 1.603-7.174-.602-14.842-5.803-20.042z"></path></g></g></svg></span>
                      </div>
                      <div className='service-item'> Terapias Visuales </div>
                      <div className='service-item-desc'> Guía de prevención y asesoramiento en higiene Visual </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='section'>
        <Container>
          <Row>
            <Col md={6}>
              <div style={{ paddingBottom: '29px' }}><img src={banner2} className='banner-col' /></div>
              <div><img src={banner3} className='banner-col' /></div>
            </Col>
            <Col md={6}>
              <div >
                <img src={banner1} className='banner-col' />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/*<div className='section'>
        <Container>
          <Row>
            <Col>
              <div className='heading-title_alt' style={{ textAlign: 'center' }}> Productos de Calidad </div>
              <div align="center"><div className='line-title' /></div>
            </Col>
          </Row>
          <Row>
            {products.map(item => (
              <Col md={3}>
                <div> <img src={item.url} className='item-img' /> </div>
                <div className='item-title'>{item.title}</div>
                <div className='item-price'>{item.price}</div>
                <div>
                  <Button className='item-button' onClick={() => handleOnItem(item)}> Detalles </Button>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>*/}

      <div ref={refFundation} className='section'>
        <Container>
          <Row className='align-items-center ani-container'>
            <Col md={6}>
              <div className='ani-col'>
                <div className='ani-title'>
                  REGALANDO SONRISAS A TRAVÉS DE LOS OJOS
                </div>
                <div align="center"><div className='line-title' /></div>
                <br />
                <div className='ani-desc'>
                  En fundación ANI realizamos campañas de salud visual en apoyo a familias y personas de escasos de recursos.
                </div>
              </div>
            </Col>
            <Col md={6} style={{ padding: 0 }}>
              <div> <img src={ani} className='ani-image' /> </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/*<div className='section'>
        <Container>
          <Row className="align-items-center" align="center">
            <Col md={ 0 } xs={ 1 } />
            <Col md={ 12 } xs={ 10 }>
              <Slider {...settings}>
              { lentes.map(item => (
                <div align="center">
                  <img
                    className="glasses-carousel"
                    src={item}
                  />
                </div>
              )) }
              </Slider>
            </Col>
            <Col md={ 0 } xs={ 1 } />
          </Row>
        </Container>
      </div>*/}

      {/*<div className='section' ref={ refFundation }>
        <div>
          <img src={ fundacion } className="fundation"></img>
        </div>
        <div className='section blue-back'>
          <Container>
            <Row className="align-items-center">
              <Col md={ 6 } align='center'>
                  <div className='fundation_title'>REGALANDO SONRISAS A TRAVÉS DE LOS OJOS</div>
                  <br/>
                  <div className='fundation_desc'>
                    En fundación ANI realizamos campañas de salud visual en apoyo a familias y personas de escasos de recursos.
                  </div>
              </Col>
              <Col md={ 6 } align='center'>
                <img src={ girl } className='girl-icon'></img>
              </Col>
            </Row>
          </Container>
        </div>
      </div>*/}

      <div className='section'>
        <Container>
          <Row>
            <div className='heading-title_alt' style={{ textAlign: 'center' }}> TESTIMONIALES </div>
            <div align="center"><div className='line-title' /></div>
          </Row>
          <br /><br />
          <Row>
            <Col md={4}>
              <Card className='custom-card'>
                <Card.Body>
                  <Card.Text>
                    <div className="card-desc">
                      Excelente servicio, acudí con mis hijos encontramos unos lentes muy bonitos y a buen precio
                    </div>
                    <br />
                    <div>
                      {/*<img src={ man } className="user-icon" />&nbsp;&nbsp;*/}
                      <span className="card-title">Aldo Dominguez</span>
                    </div>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className='custom-card'>
                <Card.Body>
                  <Card.Text>
                    <div className="card-desc">
                      ¡Todo muy bien! me realice diversos tratamientos para mis ojos, muy buen trato y todo salió excelente 🙂
                    </div>
                    <br />
                    <div>
                      {/*<img src={ woman } className="user-icon" />&nbsp;&nbsp;*/}
                      <span className="card-title">Laura Rodriguez</span>
                    </div>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className='custom-card'>
                <Card.Body>
                  <Card.Text>
                    <div className="card-desc">
                      ¡Súper recomendados! Yo done unos lentes para las campañas de apoyo a personas de bajos recursos
                    </div>
                    <br />
                    <div>
                      {/*<img src={ man } className="user-icon" />&nbsp;&nbsp;*/}
                      <span className="card-title">Pedro Ortiz</span>
                    </div>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*<div className='section'>
        <div className='map'>
          <LoadScript googleMapsApiKey="AIzaSyAlRrxNFLSDHNRgRUNAjDocYC8No8NZWL4">
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={ 18 }
              streetViewControl={ false }
              onLoad = { onLoad }
            >
              { markerPoint }

            </GoogleMap>
          
          </LoadScript>
        </div>
      </div>*/}

      <div className='section'>
        <Container className='rest-section' />
      </div>

      <div className='section' ref={refContact}>
        <Container>
          <Row>
            <Col md={1} xs={0}></Col>

            <Col md={2} className="store-col">
              <div className="service-title">Clínica</div>
              <div align="left"><div className='line-title' /> <br /></div>
              <div className="service-desc">Torre Asís, Timilpan  44, consultorio 106, Centro Urbano, Cuautitlán Izcalli. Teléfono: 55 8191 2834</div>
            </Col>
            <Col md={2} className="store-col">
              <div className="service-title">Óptica Jardines</div>
              <div align="left"><div className='line-title' /> <br /></div>
              <div className="service-desc">Av. Paseo de las Haciendas #7, colonia San Juan Atlamica, Cuautitlán Izcalli. Teléfono: 55 1676 2984</div>
            </Col>
            {/*<Col md={2} className="store-col">
              <div className="service-title">Óptica Cumbria​</div>
              <div align="left"><div className='line-title' /> <br /></div>
              <div className="service-desc">Av. Atlacomulco #68 esquina Ecatepec, colonia Cumbia, Cuautitlán Izcalli. Teléfono: 55 7024 9533</div>
            </Col>*/}
            <Col md={2} className="store-col">
              <div className="service-title">Melchor Ocampo</div>
              <div align="left"><div className='line-title' /> <br /></div>
              <div className="service-desc">Filiberto Gómez s/n barrio Señor de los Milagros, Melchor Ocampo. Teléfono: 55 8191 2834</div>
            </Col>
            <Col md={2} className="store-col">
              <div className="service-title">Óptica Bosques</div>
              <div align="left"><div className='line-title' /> <br /></div>
              <div className="service-desc">Bosques de pino #106. P.A. Bosques de la Hacienda. 1ra sección, Cuautitlán Izcalli. Teléfono: 55 7035 3116</div>
            </Col>

            {/* <Col md={ 3 } className="store-col">
              <span>
                <GeoAltFill className="store-marker"></GeoAltFill>
              </span>
              <div className="service-title">Aguascalientes​</div>
              <div className="service-desc">José María Bocanegra 607, fraccionamiento José López Portillo s/n Aguascalientes. Teléfono: 449 520 0047</div>
            </Col> */}

            <Col md={2} className="store-col">
              <div className="service-title">Tultitlán</div>
              <div align="left"><div className='line-title' /> <br /></div>
              <div className="service-desc">Blvd. Lomas de Cartagena Mz. 5, Lt. 23, Lomas de Cartagena.</div>
            </Col>

            <Col md={1} xs={0}></Col>
          </Row>
          <Row>
            <Col>
              <div>
                <br />
                <Facebook className='footer-icon' onClick={() => window.open('https://www.facebook.com/GrupoOpticoJardines')} />&nbsp;&nbsp;&nbsp;&nbsp;
                <Instagram className='footer-icon' onClick={() => window.open('https://www.instagram.com/opticajardines/')} />&nbsp;&nbsp;&nbsp;&nbsp;
                <Whatsapp className='footer-icon' onClick={() => window.open('https://wa.me/5215621397439')} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/*<div className='section section_gray2'>
        <Container>
          <Row>
            <Col>
                <div className='footer-title'>Contáctanos</div>
                <div>
                  <Facebook className='footer-icon' onClick={ () =>  window.open('https://www.facebook.com/GrupoOpticoJardines') } />&nbsp;&nbsp;&nbsp;&nbsp;
                  <Instagram className='footer-icon' onClick={ () =>  window.open('https://www.instagram.com/opticajardines/') }/>&nbsp;&nbsp;&nbsp;&nbsp;
                  <Whatsapp className='footer-icon' onClick={ () =>  window.open('https://wa.me/5215621397439') }/>
                </div>
                <br/><br/>
                <span className='footer-legals' style={{ cursor: 'pointer' }} onClick={ () => setShowPrivacy(true) }>Aviso de privacidad</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className='footer-legals' style={{ cursor: 'pointer' }} onClick={ () => setShowPolicy(true) }>Políticas de garantía</span>
                <br/>
                <div className='footer-legals'>Copyright © 2020 Grupo Óptico Jardines Desarrollado por Eureka</div>
            </Col>
          </Row>
        </Container>
      </div>*/}

    </div>
  );
}

export default App;
